import apiUrl from '../../../constants'
import axios from 'axios'
import {
  Validator
} from 'vee-validate'
import Paginate from 'vuejs-paginate'
import {
  BasicSelect
} from 'vue-search-select'
import moment from 'moment'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import DatePicker from 'vue2-datepicker'
import download from 'downloadjs';
export default {
  name: 'hub-details',
  components: {
    BasicSelect,
    VueElementLoading,
    Paginate,
    DatePicker
  },
  props: [],
  data() {
    return {
      allHub: [],
      allHubitem: {
        id: '',
        text: ''
      },
      allHubMaster: [],
      sourcehublist: [],
      hubitem: {
        id: '',
        text: ''
      },
      hubLoading: '',
      pageCount: 0,
      pageNo: 0,
      limit: 10,
      hubname: "",
      totalRecords: 0,
      tripDataLoading: false,
      srtripdata: [],
      FromDate: null,
      confirmDayClosure: false,
      downloadLoader: false,
      showButton: true
    }
  },
  computed: {},
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    }
  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext)
    this.warehouseid = userdetail[0].warehouseid;
    this.createdBy = userdetail[0].email;
    this.getHubList();
  },
  methods: {
    getHubList() {
      this.hubLoading = 'Loading Hub...'
      this.input = ({})
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'expose/hubservicecenter/dropdwon/list',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.hubLoading = ''
          this.HubDetails = result.data.ResponseData
          this.sourcehublist = []
          for (var i = 0; i < this.HubDetails.length; i++) {
            this.sourcehublist.push({
              "id": this.HubDetails[i].HubID,
              "text": this.HubDetails[i].HubName + '(' + this.HubDetails[i].HubID + ')',
            })
          }
        }, error => {
          console.error(error)
        })
    },

    SelectHub(allHubitem) {
      this.hubitem = allHubitem;
      this.hubname = this.hubitem.text;
      if (this.FromDate != "" && this.FromDate != null && this.hubitem.text != '' && this.hubitem.text != undefined) {
        this.getAllSrTrips();
      }

    },
    selectDate() {
      if (this.FromDate != "" && this.FromDate != null && this.hubitem.text != '' && this.hubitem.text != undefined) {
        this.getAllSrTrips();
      }
    },
    getAllSrTrips(cskCheck = 0) {
      if (cskCheck != 1) {
        this.tripDataLoading = true;
        this.input = ({
          "localconnectiontriptype": ['firstmile', 'lastmile'],
          "hubid": this.hubitem.id,
          "offset": this.pageNo,
          "tripstates": ['close', 'closed'],
          "limit": 10
        })
        if (this.FromDate != "" && this.FromDate != null) {
          this.input.TripStartTimeFrom = moment(this.FromDate).format('YYYY-MM-DD');
          this.input.TripStartTimeTo = moment(this.FromDate).add(1, 'days').format('YYYY-MM-DD');
        }
      } else {
        if (this.hubitem.id == '' || this.hubitem.id == null || this.hubitem.id == undefined || this.FromDate == "" || this.FromDate == null) {
          return false;
        }
        this.input = {};
        this.input = ({
          "localconnectiontriptype": ['firstmile', 'lastmile'],
          "hubid": this.hubitem.id,
          "tripstates": ['close', 'closed']
        })
        if (this.FromDate != "" && this.FromDate != null) {
          this.input.TripStartTimeFrom = moment(this.FromDate).format('YYYY-MM-DD');
          this.input.TripStartTimeTo = moment(this.FromDate).add(1, 'days').format('YYYY-MM-DD');
        }
        this.downloadLoader = true;
      }
      axios({
          'method': 'POST',
          'url': apiUrl.api_url_hubops + 'GetallLocalPickups',
          'data': this.input,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          this.tripDataLoading = false;
          this.srtripdata = result.data.ResponseData;
          if (result.data.ResultCode == 100) {
            if (cskCheck == 1) {
              this.downloadLoader = false;
              var allTripData = result.data.ResponseData;
              var csvFields = {
                'tripid': 'Trip ID',
                'triptype': 'Trip Type',
                'localtriptype': 'Local Trip Type',
                'sruserid': 'SR ID',
                'userName': 'SR Name(userName)',
                'srname': 'SR Name',
                'hubid': 'Hub ID',
                'hubname': 'hubname',
                'vehicletype': 'Vehicle Type',
                'vehicleno': 'Vehicle No',
                'vehiclevendorid': 'Vehicle Vendor ID',
                'connectionid': 'Connection ID',
                'connectionname': 'Connection Name',
                'schedulemasterid': 'ScheduleMasterID',
                'datetime': 'Trip Start Time',
                'enddatetime': 'Trip End Time',
                'openkm': 'Open Km',
                'closekm': 'Close Km',
                'manualtravelledkm': 'Total Km',
                'tripstate': 'Trip Status',
                'createdby': 'Created By',
                'lastmodifiedby': 'Last Modified By',
                'vendorname': 'Vendor Name',
                'oldDeliveryUserId': 'Old SR ID'
              };
              var dateFilder = ['datetime', 'enddatetime'];
              var skipFilter = ['_id', '', 'createdAt', 'srusertripstarttime', 'srusertripendtime', 'updatedAt', '__v', 'TotalBags', 'isPartiallyClosed', 'isPartiallyClosedDateTime', 'issqs', 'issql', 'operationType', 'lastmodifieddate', 'BagsTotalWeight', 'GpsTravelledkm', 'lhcolocaltriptype', 'routemode', 'PrimaryTripID', 'isbikeupdate', 'isvehiclereplaced', 'startlatitude', 'startlongitude', 'endlatitude', 'endlongitude', 'helpersr', 'pickuptype', 'openspeedmeterurl', 'closedspeedmeterurl', 'replacedlhcovehicles', 'isonedaysr', 'isvehiclereplaced', 'iskmupdatefromweb'];
              skipFilter.push('tripid', 'localtriptype', 'hubid', 'vehiclevendorid', 'schedulemasterid', 'connectionid', 'connectionname', 'vendorname', 'lastmodifiedby', 'createdby')
              this.jsonToCSV('TripReport', allTripData, csvFields, dateFilder, skipFilter);
            }
            let totalRows = result.data.count
            this.totalRecords = result.data.count;
            if (totalRows < 10) {
              if (totalRows == 0) {
                this.pageCount = 0
              } else {
                this.pageCount = 1
              }
            } else {
              this.pageCount = Math.ceil(totalRows / 10);
            }
          } else {
            this.$alertify.error("No Data Found");
          }

        }, error => {
          console.error(error)
        })
    },
    getPaginationData(pageNum) {
      this.pageNo = (pageNum - 1) * 10;
      this.getAllSrTrips();
    },
    resetForm() {
      //	this.allHub=[];
      //	this.allHubMaster= [];
      //	this.sourcehublist= [];
      this.hubitem = {
        id: '',
        text: ''
      };
      this.hubLoading = '';
      this.pageCount = 0;
      this.pageNo = 0;
      this.limit = 10;
      this.totalRecords = 0;
      this.tripDataLoading = false;
      this.srtripdata = [];
      this.FromDate = null
    },
    onSubmit: function(event) {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return false;
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    submitform() {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return false;
        } else {
          this.getAllSrTrips();
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    jsonToCSV(filename, data, csvfield, dateFilder = [], skipFilter = []) {
      var csvData = ''
      //Header
      var k = JSON.parse(JSON.stringify(data, [
        "hubname", "userName", "srname", "sruserid", "oldDeliveryUserId", "vehicleno", "vehicletype", "triptype", "datetime", "enddatetime", "openkm", "closekm", "manualtravelledkm", "tripstate", "tripid", "triptype", "localtriptype", "hubid", "vehiclevendorid", "connectionid", "connectionname", "schedulemasterid", "createdby", "lastmodifiedby", "vendorname"
      ]));
      if (this.title != null) {
        csvData += this.parseExtraData(this.title, '${k}\r\n')
      }
      //Fields
      for (let key in k[0]) {
        if (skipFilter.indexOf(key) == -1)
          csvData += csvfield[key] + ','
      }
      csvData = csvData.slice(0, csvData.length - 1)
      csvData += '\r\n'
      //Data
      k.map(function(item) {
        for (let key in item) {
          if (skipFilter.indexOf(key) == -1) {
            var escapedCSV = item[key] + '' // cast Numbers to string
            if (escapedCSV.match(/[,"\n]/)) {
              escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"'
            }
            if (escapedCSV == 'null')
              csvData += ',';
            else {
              if (dateFilder.indexOf(key) != -1)
                csvData += moment(escapedCSV).format('DD-MM-YY HH:mm:ss') + ','
              else
                csvData += escapedCSV + ','
            }
          }
        }
        csvData = csvData.slice(0, csvData.length - 1)
        csvData += '\r\n'
      })
      //Footer
      if (this.footer != null) {
        csvData += this.parseExtraData(this.footer, '${data}\r\n')
      }
      filename += moment().format('DD-MM-YY HH:mm:ss') + '.csv';
      return this.export(csvData, filename, "application/csv");
      return csvData
    },
    export (data, filename, mime) {
      let blob = this.base64ToBlob(data, mime)
      download(blob, filename, mime)
    },
    base64ToBlob(data, mime) {
      let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
      let bstr = atob(base64)
      let n = bstr.length
      let u8arr = new Uint8ClampedArray(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], {
        type: mime
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/SRTripDayClosure/SRTripDayClosure.component.js